import { Container, Row, Col } from "react-bootstrap";
import InfoCard from "../../components/Generic/InfoCard";
import { FiZap, FiCpu, FiBookOpen } from "react-icons/fi";

const formats = [
  {
    variant:"format",
    icon: FiZap,
    title: "Master Classes",
    description:
      "Single-session, expert-led technical deep dives offering practical, real-world insights.",
    iconVariant: "purple",
  },
  {
    variant:"format",
    icon: FiCpu,
    title: "Workshops",
    description:
      "Intensive 3–5 day online or offline crash courses designed for immersive learning.",
    iconVariant: "blue",
  },
  {
    variant:"format",
    icon: FiBookOpen,
    title: "Programs",
    description:
      "Cohort-based online learning over 6–8 weekends covering technical and non-technical skills.",
    iconVariant: "blue",
  },
];

const TrainingFormats = () => {
  return (
    <section className="py-5 text-white">
      <Container>
        <h2 className="wise-secondary-gradient mb-3">TRAINING FORMATS</h2>

        <p className="text-secondary mb-4">
          WiSE offers three training formats designed to support different
          learning needs, schedules and career stages.
        </p>

        <Row className="g-4">
          {formats.map((item, index) => (
            <Col md={4} key={index}>
              <InfoCard
                icon={item.icon}
                title={item.title}
                description={item.description}
                iconVariant={item.iconVariant}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TrainingFormats;
